import React from "react";
import Stepper from "./Stepper/Stepper";
import { EmploymentInformation } from "../pages/protector/disability/SubForms/EmploymentInformation/EmploymentInformation";
import { MedicalInformation } from "../pages/protector/disability/SubForms/MedicalInformation/MedicalInfromation";
import MedicalHistory from "../pages/protector/disability/SubForms/MedicalHistory/MedicalHistory";
import InsuranceCoverage from "../pages/protector/disability/SubForms/InsuranceCoverage/InsuranceCoverage";
import AssetsAndLiabilities from "../pages/protector/disability/SubForms/AssetsAndLiabilities/AssetsAndLiabilities";
import LegalDocuments from "../pages/protector/disability/SubForms/LegalDocuments/LegalDocuments";
import PrimaryCaregivers from "../pages/protector/disability/SubForms/PrimaryCaregivers/PrimaryCaregivers";
import HomeModification from "../pages/protector/disability/SubForms/HomeModification/HomeModification";
import EquipmentNeed from "../pages/protector/disability/SubForms/EquipmentNeeds/EquipmentNeed";
import Budget from "../pages/protector/disability/SubForms/Budget/Budget";
import ProfessionalContacts from "../pages/protector/disability/SubForms/ProfessionalContacts/ProfessionalContacts";
import DailyLivingPreferences from "../pages/protector/disability/SubForms/DailyLivingPreference/DailyLivingPreferences";
import TreatmentPreferences from "../pages/protector/disability/SubForms/TreatmentPreferences/TreatmentPreferences";
export default function DisabilityStepper() {
  const mysteps = [
    {
      step: "1",
      name: "Employment Information",
    },
    {
      step: "2",
      name: "Medical Information",
    },
    {
      step: "3",
      name: "Medical History",
    },
    {
      step: "4",
      name: "Insurance Coverage",
    },
    {
      step: "5",
      name: "Assets and Liabilities",
    },
    {
      step: "6",
      name: "Budget",
    },
    {
      step: "7",
      name: "Legal Documents",
    },
    {
      step: "8",
      name: "Primary Caregivers",
    },
    {
      step: "9",
      name: "Professional Contacts",
    },
    {
      step: "10",
      name: "Home Modifications",
    },
    {
      step: "11",
      name: "Equipment Needs",
    },
    {
      step: "12",
      name: "Daily Living Preferences",
    },
    {
      step: "13",
      name: "Treatment Preferences",
    },
  ];

  const contentComponents = [
    EmploymentInformation,
    MedicalInformation,
    MedicalHistory,
    InsuranceCoverage,
    AssetsAndLiabilities,
    Budget,
    LegalDocuments,
    PrimaryCaregivers,
    ProfessionalContacts,
    HomeModification,
    EquipmentNeed,
    DailyLivingPreferences,
    TreatmentPreferences
  ];

  return (
    <>
      <Stepper steps={mysteps} contentComponents={contentComponents} />
    </>
  );
}
